// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2023":"9ef2f960","2146":"9ef2f960","2438":"9ef2f960","3104":"9ef2f960","3428":"9ef2f960","4886":"9ef2f960","6110":"9ef2f960"}[chunkId] + ".chunk.css";
};